$(document).ready(function(){
  $('.press-carousel').slick({
    infinite: true,
    autoplay: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.reviews-carousel').slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  MicroModal.init({
    onShow: (a,b,c,d,e,f) => console.log($(a)),
    onClose: function(modal){
      console.log('modal');
      $('#' + modal.id + ' iframe').removeAttr('src');
    }
  });

  $('[data-modal-video]').on('click', function() {
    var modal = $(this).data('modal');
    var video = $(this).data('video');

    $('#' + modal).find('iframe').attr('src', video);
  });

  $('.product-swatch-inline__dot').on('mouseenter', function(){
    var image = $(this).data('image');
    $(this).closest('.product-block').find('.product-block__image .image-one .rimage__image').attr('src', image).attr('data-src', image).attr('srcset', image);
  }).on('mouseleave', function(){
    var original = $(this).closest('.product-block').find('.product-block__image .image-one').data('original');
    $(this).closest('.product-block').find('.product-block__image .image-one .rimage__image').attr('src', original).attr('data-src', original).attr('srcset', original);
  });
  
  $('[data-single-option-selector]').on('change', function(e){
    
    var option = $(this).find('option:selected');
    if($(option).data('href')){
      console.log('epa');
      $('.payment-buttons').addClass('temp-hidden');
      e.stopPropagation();
      window.location.href = $(option).data('href');
    }
  });
});
